module.exports = __webpack_public_path__ + "img/3M7A2122n.daec08f5.png";